import React from 'react'

function Header() {
  return (
    <div className ="text-center">
      <h1 className='display-2'>Welcome to Flatiron Wordle!</h1>
      <p className='display-6'>Created by Omar and James</p>
    </div>
  )
}

export default Header